import { stringEnum } from 'common/utils/objects';
import { EnumValues } from 'common/types';
import { ShopFeatures } from 'common/modules/plans';

export const CustomerPersonas = stringEnum(['DISCOVERING', 'REPLACING', 'PLAYING', 'AGENCIES']);
export type CustomerPersona = EnumValues<typeof CustomerPersonas>;

export const IndustryCategories = stringEnum([
	'WINTERSPORTS',
	'WATERSPORTS',
	'BIKES_SCOOTERS',
	'ADVENTURE_OUTDOORS',
	'OTHER_SPORTS',
	'VEHICLES_BOATS',
	'CLOTHING_FASHION',
	'TOOLS_CONSTRUCTION',
	'CAMERA_AV',
	'EVENTS_DECOR',
	'FURNITURE',
	'TECH_ELECTRONICS',
	'BABY_MATERNITY',
	'GUIDED_ACTIVITIES_TOURS',
	'ENTRANCE_TICKETS',
	'RETAIL_E-COMMERCE',
	'RETAIL_IN-STORE',
	'OTHER',
]);
export type IndustryCategory = EnumValues<typeof IndustryCategories>;

export interface IndustryOption {
	type: IndustryCategory;
	text: string;
}

export interface ShopAnalytics {
	id: string;
	shopId?: string;
	customerPersona?: CustomerPersona;
	industryCategories?: IndustryCategory[];
	pricingChanges?: {
		[storeId: string]: StorePricingChange[];
	};
	showOnboarding?: boolean;
	onboardingActions?: {
		[key in OnboardingAction]?: boolean;
	};
	churn?: {
		timestamp: string;
		reasonsForDowngrade: ChurnReason[];
		missingFeatures?: string;
		nextPlatform?: string;
		additionalInformation?: string;
	};
}

export const OnboardingSteps = [
	'APPEARANCE_ONLINE_STORE',
	'ARTICLE_CREATION',
	'BOOKING_COMPLETION',
	'BOOKING_CREATION',
	'BUSINESS_CONTACT_INFORMATION',
	'BUSINESS_ID',
	'CANCELLATION_POLICY',
	'LINK_ONLINE_STORE',
	'LOGO',
	'OPENING_HOURS',
	'PAYMENTS',
	'PRIVACY_POLICY',
	'PRODUCT_CREATION',
	'PRODUCT_SKU_CONNECTION',
	'REGIONAL_FORMATS',
	'SKU_CREATION',
	'STORE_DETAILS',
	'TAX_RATES',
	'USERS',
	'TERMS_OF_SERVICE',
	'VERIFY_LANGUAGE',
] as const;

export const OnlyOnboardingActions = [
	'VISIT_ONLINE_STORE_BUTTON',
	'VISIT_ONLINE_STORE_MODAL',
	'VISIT_ONLINE_STORE', // Deprecated
	'VISIT_BOOKINGS', // Deprecated
] as const;

export const OnboardingActions = [...OnboardingSteps, ...OnlyOnboardingActions] as const;

export type OnboardingAction = typeof OnboardingActions[number];

export type ChurnReason =
	| 'FEATURES'
	| 'PRICE'
	| 'SALES'
	| 'SETTING_UP'
	| 'TEMPORARY_USE'
	| 'CLOSING_STORE'
	| 'OTHER_PLATFORM'
	| 'OTHER_REASON_FOR_DOWNGRADE';

export type StorePricingChange = {
	timestamp: string | null; // null means unknown (existing clients for whom this has not been tracked)
	features: ShopFeatures | null; // null means store was deleted
};
